import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useSetUserLogout } from "../../API_Master/MutateAPI";
import Loader from "../../CommonComponents/Loader";
import { mainRouteInitial } from "../../Data/Constant";
import "./index.css";

const TopMenubar = () => {
  const [dropDownProfileMenu, setDropDownProfileMenu] = useState(false);
  const { DarkTheme } = useSelector((state) => state.ProjectSlice);
  const navigate = useNavigate();
  const boxRef = useRef(null);

  const { isLoading: isLoggingOut } = useSetUserLogout();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setDropDownProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChangeDropDownProfileMenu = () => {
    setDropDownProfileMenu(!dropDownProfileMenu);
  };

  const handleLogOut = () => {
    Cookies.remove("Narendra_Modi_UserID");
    Cookies.remove("Narendra_Modi_UserName");
    Cookies.remove("Mukesh_Patel_UserMobile");
    Cookies.remove("Narendra_Modi_LoginFrom");
    Cookies.remove("Narendra_Modi_UserUniqueID");
    Cookies.remove("Narendra_Modi_SessionExpireTime");
    Cookies.remove("Narendra_Modi_Village_ID");
    Cookies.remove("isLoggedIn");
    localStorage.removeItem("isLoggedIn");
    navigate(`/${mainRouteInitial}/Login`);
  };

  const avatarSrc = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/assets/img/avatars/1.jpg` : `/${mainRouteInitial}/assets/img/avatars/1.jpg`;

  return (
    <>
      <header className={`w-100 d-flex flex-row flex-nowrap align-items-center justify-content-between px-4 py-2 ${DarkTheme ? "darkMode" : ""}`}
        style={{
          backgroundColor: "#ffffff",
          borderBottom: "1px solid #e5e7eb",
          minHeight: "68px",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >

        {/* <div className="d-flex align-items-center">
          <img
            src={require("../../Assets/NarendraModiLogo.png")}
            alt="Logo"
            style={{
              height: "50px",
              width: "auto",
              maxHeight: "52px",
              objectFit: "contain",
              cursor: "pointer",
            }}
          />
        </div> */}

        <div className="topMenubar-brandBlock">
          <div className="topMenubar-brandText">
            <span className="topMenubar-brandName">Narendra Modi</span>
            <span className="topMenubar-brandSubtitle">
              <span></span>
              {/* <span className="topMenubar-triDot topMenubar-triDot--saffron"></span>
              <span className="topMenubar-triDot topMenubar-triDot--white"></span>
              <span className="topMenubar-triDot topMenubar-triDot--green"></span> */}
              Prime Minister of India
            </span>
          </div>
        </div>

        <div className="position-relative" ref={boxRef}>
          <div
            onClick={handleChangeDropDownProfileMenu}
            style={{
              cursor: "pointer",
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={avatarSrc}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/img/avatars/1.jpg";
              }}
              alt="Profile"
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #ffffff",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            />
            <span
              style={{
                position: "absolute",
                bottom: "1px",
                right: "1px",
                width: "11px",
                height: "11px",
                backgroundColor: "#22c55e",
                borderRadius: "50%",
                border: "2px solid #ffffff",
              }}
            />
          </div>

          {dropDownProfileMenu && (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "calc(100% + 10px)",
                minWidth: "220px",
                backgroundColor: "#ffffff",
                borderRadius: "14px",
                boxShadow: "0 12px 36px rgba(0, 0, 0, 0.16)",
                border: "1px solid rgba(0, 0, 0, 0.07)",
                padding: "16px",
                zIndex: 1050,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <div style={{ marginBottom: "14px", position: "relative", display: "inline-flex" }}>
                <img
                  src={avatarSrc}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/img/avatars/1.jpg";
                  }}
                  alt="Profile"
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    bottom: "2px",
                    right: "2px",
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#22c55e",
                    borderRadius: "50%",
                    border: "2px solid #ffffff",
                  }}
                />
              </div>

              <button
                onClick={handleLogOut}
                style={{
                  width: "100%",
                  backgroundColor: "#f93b3b",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 14px",
                  fontWeight: "600",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 4px 12px rgba(249, 59, 59, 0.35)",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                Logout
                <LogOut size={16} strokeWidth={2.4} />
              </button>
            </div>
          )}
        </div>
      </header>




      {isLoggingOut && <Loader />}
    </>
  );
};

export default TopMenubar;
